import React from 'react';
import PropTypes from 'prop-types';
import SmallCalNavBar from './nav-bar';
import Day from './day-cell';
import DatePicker from '../DatePicker';
import styles from './cal-styles.css';

export const getFromTo = (date) => {
  const from = new Date(date.getTime());
  from.setDate(date.getDate() - date.getDay());

  const to = new Date(from.getTime());
  to.setDate(from.getDate() + 6);

  return [from, { from, to }];
};

export const getSelectedDays = (date, view) => {
  if (view === 'week') {
    return getFromTo(date);
  } else {
    return date.toDateString() === new Date().toDateString() ? null : date;
  }
};

const CalendarSmall = ({ onDayClick, currentDate, currentView, onNavigate }) => (
  <div styleName={`${currentView === 'week' ? 'week' : 'day'}-selected`}>
    <DatePicker
      todayButton=""
      enableOutsideDays
      classNames={styles}
      navbarElement={<SmallCalNavBar onNavigate={onNavigate} />}
      onDayClick={onDayClick}
      renderDay={Day}
      selectedDays={getSelectedDays(currentDate, currentView)}
      month={currentDate}
    />
  </div>
);

CalendarSmall.propTypes = {
  onDayClick: PropTypes.func,
  currentView: PropTypes.string,
  currentDate: PropTypes.instanceOf(Date),
  onNavigate: PropTypes.func.isRequired,
};

export default CalendarSmall;
